<!-- src/components/StraitTabs.svelte -->
<script>
  import { onMount } from 'svelte'
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/ScrollTrigger'
  import { navigableStraits } from '../data/straitScenes.js'
  import { currentSceneId } from '../stores/SceneDataStore.js'

  let visible = false
  let activeSceneId = null
  currentSceneId.subscribe(id => { activeSceneId = id })

  function jumpTo(sceneId) {
    // v10:用 scroll-anchor-${sceneId},由 StraitMapStepScroller 渲染出來
    const target = document.querySelector(`#scroll-anchor-${sceneId}`)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      return
    }
    const fallback = document.querySelector('.scene-wrap')
    if (fallback) fallback.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  onMount(() => {
    gsap.registerPlugin(ScrollTrigger)
    setTimeout(() => {
      ScrollTrigger.create({
        trigger: '.map-stage-container',
        start: 'top top',
        end: 'bottom bottom',
        onEnter: () => visible = true,
        onEnterBack: () => visible = true,
        onLeave: () => visible = false,
        onLeaveBack: () => visible = false,
      })
    }, 500)
  })
</script>

<div class="strait-tabs" class:visible>
  {#each navigableStraits as strait}
    <button class="strait-tab"
      class:active={activeSceneId === strait.id}
      on:click={() => jumpTo(strait.id)}>
      {strait.label}
    </button>
  {/each}
</div>

<style>
  .strait-tabs {
    position: fixed; top: 0; left: 0; right: 0; z-index: 100;
    background: rgba(243, 241, 236, 0.96);
    backdrop-filter: blur(8px);
    border-bottom: 1px solid #d0cdc6;
    padding: 0.6rem 1rem;
    display: flex; gap: 0.4rem;
    overflow-x: auto; justify-content: center;
    transform: translateY(-100%); transition: transform 0.4s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
  .strait-tabs.visible { transform: translateY(0); }
  .strait-tab {
    background: transparent;
    border: 1px solid transparent;
    color: var(--color-text-dim, #777777);
    padding: 0.4rem 0.9rem;
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 0.85rem;
    cursor: pointer; white-space: nowrap;
    transition: all 0.2s;
    letter-spacing: 0.05em;
  }
  .strait-tab:hover { color: var(--color-text, #222222); }
  .strait-tab.active {
    color: var(--color-accent, #d44545);
    border-color: var(--color-accent, #d44545);
    font-weight: 600;
  }
</style>
